import { render } from "./ModalOrders.vue?vue&type=template&id=65da5db0"
import script from "./ModalOrders.vue?vue&type=script&lang=js"
export * from "./ModalOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__